// extracted by mini-css-extract-plugin
module.exports = {"list":"AdList_list__H5FCJ","header":"AdList_header__276bQ","total_count":"AdList_total_count__2Tn5M"};